<template>

  <div id="af3-shortcodes-fees-component">
    <table>
      <thead>
        <tr>
          <th>Charge Code Description</th>
          <th class="price">Detailed Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="fee in property_fees" :key="fee.id">
          <td>{{ fee.chargeCodeDescription }}
            <template v-if="fee.chargeTiming">
             <span class="charge-timing">Charge Timing: {{ fee.chargeTiming }}</span>
            </template>
          </td>
          <td class="price">${{ fee.detailedAmount }}</td>
        </tr>
      </tbody>
    </table>
  </div>


</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive  } from 'vue';


export default defineComponent({
    components: { },
   
    props: { 
      options: {
        type: Object,
        required: true
      },
      resources_url: {
        type: String,
        required: true
      },
      floor_plans: {
        type: Array,
        required: true
      },
      property_fees: {
        type: Array,
        required: true
      }
    },

    setup(props) {

               

    return {
    };
  },


  
  
});
</script>